module.exports = __webpack_public_path__ + "img/摄图网_500431060_banner.0ecf0f6f.png";